import Icon from '@material-ui/icons/AccountTree'
import { ROLES } from 'utils/user'

export default {
  icon: Icon,
  permissions: [ROLES.ROLE_ADMIN, ROLES.ROLE_FINANCE],
}
